import {
  WorkspaceUserActionTypes,
  ICreateWorkspaceUsersPayload,
  IDeleteWorkspaceUserPayload,
  IDeleteWorkspaceUserSuccessPayload,
} from './types'

export const createWorkspaceUsers = (payload: ICreateWorkspaceUsersPayload) => ({
  type: WorkspaceUserActionTypes.CREATE_WORKSPACE_USERS,
  payload,
})

export const createWorkspaceUsersSuccess = () => ({
  type: WorkspaceUserActionTypes.CREATE_WORKSPACE_USERS_SUCCESS,
})

export const createWorkspaceUsersFailure = () => ({
  type: WorkspaceUserActionTypes.CREATE_WORKSPACE_USERS_FAILURE,
})

export const deleteWorkspaceUser = (payload: IDeleteWorkspaceUserPayload) => ({
  type: WorkspaceUserActionTypes.DELETE_WORKSPACE_USER,
  payload,
})

export const deleteWorkspaceUserSuccess = (payload: IDeleteWorkspaceUserSuccessPayload) => ({
  type: WorkspaceUserActionTypes.DELETE_WORKSPACE_USER_SUCCESS,
  payload,
})

export const deleteWorkspaceUserFailure = () => ({
  type: WorkspaceUserActionTypes.DELETE_WORKSPACE_USER_FAILURE,
})
